<p-card header="Summary">
  <div class="p-grid">
    <div class="p-col-12">
      <div *ngIf="showComponentsFields">
        <h3>Builder Repairs Components Used</h3>
        <form [formGroup]="componentsForm">
          <input type="text" size="27" pInputText formControlName="componentsNumber" class="boldNumber" lib-numeric (change)="onChangeComponentsNumber()"/>
        </form>
      </div>
      <h3>{{inventoryString}}</h3>
      <form [formGroup]="inventoryForm">
        <input type="text" size="27" pInputText formControlName="inventoryNumber" class="boldNumber" lib-numeric (change)="onChangeInventoryNumber()"/>
      </form>
      <h3>{{repairsByTempString}}</h3>
      <form [formGroup]="inventoryForm">
        <input type="text" size="27" pInputText formControlName="repairsByTempNumber" class="boldNumber" lib-numeric (change)="onChangeInventoryNumber()"/>
      </form>
      <h3>{{totalString}}</h3>
      <input type="text" size="27" pInputText [disabled]="disabled || weekIsClosed" value={{totalNumber}} class="boldNumber"/>

      <div *ngIf="combinedShiftFlag">
        <h3 class="otherShiftsTitle">Other Shifts</h3>
        <form [formGroup]="otherShiftsForm">
          <div class="otherShifts">
            <h5 class="otherShiftsLabel">Inv. Repairs</h5>
            <input formControlName="invRepairs" type="text" size="5" pInputText [disabled]="disabled || weekIsClosed" class="boldNumber"/>
          </div>
          <div class="otherShifts">
            <h5 class="otherShiftsLabel">Builder Repairs</h5>
            <input formControlName="builderRepairs" type="text" size="5" pInputText [disabled]="disabled || weekIsClosed" class="boldNumber"/>
          </div>
          <div class="otherShiftsLast">
            <h5 class="otherShiftsLabel"># Builders</h5>
            <input formControlName="numberBuilders" type="text" size="5" pInputText [disabled]="disabled || weekIsClosed" class="boldNumber"/>
          </div>
        </form>
      </div>
      <h3>{{averageString}}</h3>
      <input type="text" size="27" pInputText [disabled]="disabled || weekIsClosed" value={{averageNumber}} class="boldNumber"/>
      <div *ngIf="showComponentsFields">
        <h3>Components Per Repair</h3>
        <form [formGroup]="componentsForm">
          <input type="text" size="27" pInputText formControlName="componentsPerRepairNumber" class="boldNumber" lib-numeric/>
        </form>
      </div>
    </div>
  </div>
</p-card>
